(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Header: border on scroll + mobile menu ------------------------------ */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  var menu = $('[data-mobile-menu]');
  var openBtn = $('[data-menu-open]');
  var closeBtn = $('[data-menu-close]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });

  /* Water check: open the municipal waterworks search ------------------- */
  var wc = $('[data-water-check]');
  if (wc) {
    $('[data-water-go]', wc).addEventListener('click', function () {
      var pref = $('[data-water-pref]', wc).value;
      if (!pref) { $('[data-water-pref]', wc).focus(); return; }
      var q = encodeURIComponent(pref + ' 水道局 水質検査結果');
      window.open('https://www.google.com/search?q=' + q, '_blank', 'noopener');
    });
  }

  /* Voices filter -------------------------------------------------------- */
  var pills = $('[data-voice-pills]');
  if (pills) {
    pills.addEventListener('click', function (e) {
      var b = e.target.closest('[data-voice-filter]');
      if (!b) return;
      $$('.pill', pills).forEach(function (p) { p.classList.toggle('is-active', p === b); });
      var tag = b.getAttribute('data-voice-filter');
      $$('[data-voice-tag]').forEach(function (v) {
        v.hidden = !!tag && v.getAttribute('data-voice-tag') !== tag;
      });
    });
  }

  /* Cart: quantity steppers on the cart page ---------------------------- */
  $$('[data-line-qty]').forEach(function (input) {
    var wrap = input.parentNode;
    $('[data-line-minus]', wrap).addEventListener('click', function () { input.value = Math.max(0, (+input.value || 0) - 1); });
    $('[data-line-plus]', wrap).addEventListener('click', function () { input.value = (+input.value || 0) + 1; });
  });

  /* Product page --------------------------------------------------------- */
  var section = $('[data-product-section]');
  if (!section) return;
  var dataEl = $('[data-product-data]');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var bundleEl = $('[data-bundle-data]');
  var bundle = bundleEl ? JSON.parse(bundleEl.textContent) : null;

  var form = $('form[action*="/cart/add"]', section);
  var variantInput = $('[data-variant-input]', form);
  var planInput = $('[data-plan-input]', form);
  var modes = $$('[data-mode]', form);
  var atc = $('[data-atc]', form);
  var atcLabel = $('[data-atc-label]', form);
  var priceSub = $('[data-price-subscribe]', form);
  var priceOnce = $('[data-price-once]', form);
  var nextBox = $('[data-next]', form);
  var nextLabel = $('[data-next-label]', form);
  var nextPrice = $('[data-next-price]', form);
  var stickyPrice = $('[data-sticky-price]');
  var hhBox = $('[data-household]', form);
  var planBox = $('[data-plan-options]', form);
  var termsPlan = $('[data-terms-plan]', form);
  var recoWrap = $('[data-reco-wrap]', form);
  var recoEl = $('[data-reco]', form);
  var qty = $('[data-qty]', form);
  var currency = section.getAttribute('data-currency') || 'JPY';
  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, maximumFractionDigits: currency === 'JPY' ? 0 : 2 });
  var money = function (cents) { return fmt.format(cents / 100); };

  var state = { hh: hhBox ? (+hhBox.getAttribute('data-default') || 1) : 0, plan: '', touchedPlan: false };

  function selectedOptions() {
    return $$('fieldset[data-option-index]', form).map(function (fs) {
      var c = $('input:checked', fs);
      return c ? c.value : null;
    });
  }
  function currentVariant() {
    var opts = selectedOptions();
    if (!opts.length) return data.variants[0];
    return data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0] || null;
  }
  function priceHtml(price, compare) {
    return compare > price ? '<span class="sale">' + money(price) + '</span> <s class="compare">' + money(compare) + '</s>' : money(price);
  }
  function mode() {
    var m = modes.filter(function (r) { return r.checked; })[0];
    return m ? m.value : 'once';
  }

  /* Plans available for the current variant (own plans, or the bundled cartridge's plans) */
  function plansFor(v) {
    if (bundle) return bundle.plans;
    if (!v) return [];
    return v.allocations.map(function (a) {
      return { id: String(a.plan), name: data.plans[a.plan] || '定期便', price: a.price, compare: a.compare || v.price };
    });
  }
  function norm(t) { return String(t || '').replace(/[\s\u3000]+/g, '').replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 65248); }).replace(/ヶ月|ヵ月|カ月/g, 'か月'); }
  function pick(plans, key) {
    if (!key) return null;
    var k = norm(key);
    return plans.filter(function (p) { return norm(p.name).indexOf(k) > -1; })[0] || null;
  }
  /* "3 か月ごとに配達, 5% オフ" -> "3か月ごと" */
  function label(p) {
    var m = norm(p.name).match(/(\d+)(か月|週間|日)/);
    return m ? m[1] + m[2] + 'ごと' : p.name;
  }
  function recommended(plans) {
    if (!hhBox) return null;
    var slow = pick(plans, hhBox.getAttribute('data-slow'));
    var fast = pick(plans, hhBox.getAttribute('data-fast'));
    var th = +hhBox.getAttribute('data-threshold') || 3;
    return (state.hh >= th ? (fast || slow) : (slow || fast)) || null;
  }
  function planById(plans, id) {
    return plans.filter(function (p) { return p.id === id; })[0] || null;
  }

  function renderPlans(plans) {
    if (!planBox) return;
    planBox.innerHTML = '';
    plans.forEach(function (p, i) {
      var id = 'plan-' + i + '-' + Math.round(Math.random() * 1e6);
      var input = document.createElement('input');
      input.type = 'radio'; input.name = 'plan-radio'; input.id = id; input.value = p.id;
      input.checked = p.id === state.plan;
      var lbl = document.createElement('label');
      lbl.setAttribute('for', id);
      lbl.textContent = label(p);
      planBox.appendChild(input);
      planBox.appendChild(lbl);
    });
  }

  function update() {
    var v = currentVariant();
    if (!v) {
      atc.disabled = true;
      atcLabel.textContent = data.soldOut;
      return;
    }
    variantInput.value = v.id;

    var plans = plansFor(v);
    var hasPlans = plans.length > 0 && (!bundle || bundle.available);

    /* household -> recommended plan */
    var rec = recommended(plans);
    if (hhBox) {
      var canRecommend = !!(pick(plans, hhBox.getAttribute('data-slow')) || pick(plans, hhBox.getAttribute('data-fast')));
      hhBox.hidden = !canRecommend;
      $$('[data-hh]', hhBox).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-hh') === state.hh)); });
      if (recoWrap) recoWrap.hidden = !rec;
      if (recoEl && rec) recoEl.textContent = label(rec);
    }
    if (!planById(plans, state.plan)) {
      state.plan = (rec || plans[0] || { id: '' }).id;
    }
    renderPlans(plans);
    var chosen = planById(plans, state.plan);

    /* price rows */
    if (priceOnce) priceOnce.innerHTML = priceHtml(v.price, v.compare);
    if (priceSub && chosen) {
      if (bundle) priceSub.innerHTML = '<span class="buyopt__first">初回</span>' + priceHtml(Math.max(0, v.price - bundle.discount + chosen.price), v.price);
      else priceSub.innerHTML = priceHtml(chosen.price, chosen.compare || v.price);
    }
    if (nextBox && bundle && chosen) {
      nextBox.hidden = false;
      nextLabel.innerHTML = '<b>2回目以降</b>交換用フィルター（' + label(chosen) + '）';
      nextPrice.innerHTML = money(chosen.price) + '<small>1回あたり・税込</small>';
    }
    if (planBox) { var planSet = planBox.closest('fieldset'); if (planSet) planSet.style.display = plans.length < 2 ? 'none' : ''; }
    var saveTag = $('[data-opt="subscribe"] .buyopt__tag', form);
    if (saveTag && bundle && chosen) {
      var saved = bundle.discount - chosen.price;
      saveTag.hidden = saved <= 0;
      if (saved > 0) saveTag.textContent = '1回のみ購入より' + money(saved) + 'おトク';
    }
    if (termsPlan) {
      termsPlan.textContent = chosen
        ? (bundle ? '2回目以降は、交換用フィルター（カートリッジ）を' : '') + label(chosen) + 'にお届け。1回あたり ' + money(chosen.price) + '（税込）'
        : '';
    }

    /* subscribe option availability */
    var subRadio = modes.filter(function (r) { return r.value === 'subscribe'; })[0];
    if (subRadio) {
      subRadio.disabled = !hasPlans;
      if (!hasPlans && subRadio.checked) {
        var once = modes.filter(function (r) { return r.value === 'once'; })[0];
        if (once) once.checked = true;
      }
    }
    modes.forEach(function (r) { r.closest('.buyopt').classList.toggle('is-checked', r.checked); });

    var subscribing = modes.length > 0 && mode() === 'subscribe' && hasPlans;
    if (planInput) {
      var native = subscribing && !bundle;
      planInput.disabled = !native;
      planInput.value = native ? state.plan : '';
    }

    var shown = v.price;
    if (subscribing) {
      shown = bundle ? Math.max(0, v.price - bundle.discount + (chosen ? chosen.price : 0)) : (chosen ? chosen.price : v.price);
    }
    if (stickyPrice) stickyPrice.textContent = (subscribing && bundle ? '初回 ' : '') + money(shown);
    atc.disabled = !v.available;
    atcLabel.textContent = v.available ? data.addToCart : data.soldOut;

    if (history.replaceState && data.variants.length > 1) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
    if (v.media) {
      var t = $('[data-thumb][data-media-id="' + v.media + '"]');
      if (t) t.click();
    }
  }

  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'plan-radio') { state.plan = e.target.value; state.touchedPlan = true; }
    update();
  });
  if (hhBox) {
    hhBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hh]');
      if (!b) return;
      state.hh = +b.getAttribute('data-hh');
      var rec = recommended(plansFor(currentVariant()));
      if (rec) state.plan = rec.id;
      state.touchedPlan = false;
      update();
    });
  }
  update();

  /* Gallery */
  var mainImg = $('[data-gallery-image]');
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) mainImg.src = t.getAttribute('data-src');
      $$('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
    });
  });

  /* Quantity */
  $('[data-qty-minus]', form).addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) - 1); });
  $('[data-qty-plus]', form).addEventListener('click', function () { qty.value = (+qty.value || 1) + 1; });

  /* Head + cartridge subscription goes into the cart as two lines in one request */
  form.addEventListener('submit', function (e) {
    var v = currentVariant();
    if (!bundle || mode() !== 'subscribe' || !state.plan || !v || !v.available) return;
    e.preventDefault();
    atc.disabled = true;
    var q = Math.max(1, +qty.value || 1);
    var body = {
      items: [
        { id: v.id, quantity: q },
        { id: bundle.variant, quantity: q, selling_plan: +state.plan }
      ]
    };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { atc.disabled = false; alert('カートに追加できませんでした。時間をおいてお試しください。'); });
  });

  /* Sticky add-to-cart (mobile) */
  var sticky = $('[data-sticky-atc]');
  if (sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    });
    io.observe(atc);
    $('[data-sticky-btn]', sticky).addEventListener('click', function () {
      if (!atc.disabled) form.requestSubmit();
    });
  }
})();
